import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import "./markdown.scss";

interface IMarkdownProps {
  markdownText: string;
}

export function formatMarkdownBreaks(markdownText: string) {
  if (markdownText === undefined || markdownText === null) {
    return "";
  } else {
    const markdownTextLines = markdownText.split("\n");
    const formattedMarkdownTextLines = markdownTextLines.map(line => line + "  ").join("\n");

    return formattedMarkdownTextLines;
  }
}

export default function Markdown(props: IMarkdownProps) {
  const customSanitize = {
    ...defaultSchema,
    attributes: {
      ...defaultSchema.attributes,
      img: [...(defaultSchema.attributes.img || []), "style"],
    },
  };

  // This to only allow width and height styles in img tags
  const sanitizeStylePlugin = () => {
    return tree => {
      // Start walking the tree from the root.
      walk(tree);
    };
  };

  // A recursive function to traverse the tree.
  function walk(node) {
    // 1. Process the current node.
    // Check if it's an element with a style property.
    if (node.type === "element" && node.properties && typeof node.properties.style === "string") {
      const styleString = node.properties.style as string;
      const allowedProperties = ["width", "height"];

      const sanitizedStyles = styleString
        .split(";")
        .map(declaration => declaration.trim())
        .filter(Boolean)
        .filter(declaration => {
          const propertyName = declaration.split(":")[0].trim().toLowerCase();
          return allowedProperties.includes(propertyName);
        })
        .join("; ");

      if (sanitizedStyles) {
        node.properties.style = sanitizedStyles;
      } else {
        delete node.properties.style;
      }
    }

    // 2. If the node has children, recurse into them.
    if (node.children && Array.isArray(node.children)) {
      for (const child of node.children) {
        walk(child); // This is the recursive call
      }
    }
  }

  return (
    <ReactMarkdown
      className="markdown-display h-[revert]"
      rehypePlugins={[rehypeRaw, [rehypeSanitize, customSanitize], sanitizeStylePlugin]}
    >
      {formatMarkdownBreaks(props.markdownText)}
    </ReactMarkdown>
  );
}
